import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { useEvent, useEventDetails } from '../context';
import { useViewOnlySecret } from '../hooks/useViewOnlySecret';
import NoEventError from './NoEventError';

interface Props {
    eventId: string;
}

export default function EventMapHeader(props: Props) {
    const { viewOnly, secret } = useViewOnlySecret();
    const useDetailsForHeader = viewOnly && secret != null;

    const eventFromList = useEvent(useDetailsForHeader ? undefined : props.eventId);
    const { event: eventFromDetails, isLoading } = useEventDetails(useDetailsForHeader ? props.eventId : undefined);

    const event = useDetailsForHeader ? eventFromDetails : eventFromList;

    if (useDetailsForHeader && isLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 56, mt: 2, mb: 2 }}>
                <CircularProgress size={28} />
            </Box>
        );
    }

    if (!event) {
        return <NoEventError eventId={props.eventId} />;
    }

    return (
        <Stack direction="row" sx={{ width: '100%', mt: 2, mb: 2, px: 2, alignItems: 'center', justifyContent: 'center' }}>
            <Typography
                variant="h3"
                sx={{
                    fontWeight: 500,
                    fontSize: '2rem',
                    letterSpacing: '-0.01em',
                    wordWrap: 'break-word',
                    overflowWrap: 'break-word',
                    textAlign: 'center',
                }}
            >
                {event.name}
            </Typography>
        </Stack>
    );
}
